// LocationIcon.tsx
import React from 'react';
import styled from 'styled-components';
import { MdLocationOn } from 'react-icons/md';

// Style the wrapper
const StyledIconWrapper = styled.div`
  width: 30px;
  height: 30px;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
  transition: fill 0.2s ease;

  svg {
    width: 100%;
    height: 100%;
    color: #ffffff;
  }
`;

// Type MdLocationOn as a proper React component
const TypedMdLocationOn = MdLocationOn as unknown as React.FC<{ size?: number | string }>;

const LocationIcon: React.FC = () => (
  <StyledIconWrapper>
    <TypedMdLocationOn size={24} />
  </StyledIconWrapper>
);

export default LocationIcon;